
































import LicencePreferences from '@accountFederation/modules/licencePreferences/standard/LicencePreferences.vue';
import {
    SdsAlert,
    SdsButton,
    SdsContentLoader,
} from '@superbet-group/web.lib.ui-components';
import {
    defineComponent,
    ref,
} from '@vue/composition-api';
import { UserService } from '@core/services/user/UserService';
import {
    BgcLicence,
    LicenceState,
} from '@accountFederation/modules/licencePreferences/types';
import { LicencePreferencesPayload } from '@core/services/user/_private/Types';
import { getAccountConfig } from '@accountFederation/config/accountConfig';

export default defineComponent({
    name: 'LicencePreferencesContainer',
    setup() {
        const initialPreferencesState = ref<Partial<Record<BgcLicence, LicenceState>> | null>(null);
        const preferencesState = ref<LicencePreferencesPayload>();
        const hasError = ref(false);
        const isSaving = ref(false);

        async function submitPreferences() {
            if (!preferencesState.value) {
                return;
            }

            isSaving.value = true;

            try {
                await UserService.getInstance().updateUserLicencePreferences(preferencesState.value);
            } catch (e) {
                hasError.value = true;
            }

            isSaving.value = false;
        }

        async function getPreferences() {
            initialPreferencesState.value = (await UserService.getInstance().getUserLicencePreferences()).data.licences;
        }

        function changeLicencePreferenceState(newState: LicencePreferencesPayload): void {
            preferencesState.value = newState;
        }

        getPreferences();

        return {
            initialPreferencesState,
            hasError,
            isSaving,
            saveLabel: getAccountConfig().areSitesSplitByLicence ? 'pam.licencePreference.save' : 'pam.licencePreferences.save',
            changeLicencePreferenceState,
            submitPreferences,
        };
    },
    components: {
        LicencePreferences,
        SdsButton,
        SdsContentLoader,
        SdsAlert,
    },
});
